import { c as _c } from "react/compiler-runtime";
import type * as React from 'react';
import { cn } from '@/app/_lib/utils';
type PythonLogoProps = React.SVGProps<SVGSVGElement> & {
  size?: number;
  color?: string;
};
export const PythonLogo: React.FC<PythonLogoProps> = t0 => {
  const $ = _c(24);
  let props;
  let t1;
  let t2;
  let t3;
  let t4;
  let t5;
  let t6;
  let t7;
  let t8;
  let t9;
  if ($[0] !== t0) {
    const {
      size: t10,
      width,
      height,
      ...t11
    } = t0;
    props = t11;
    const size = t10 === undefined ? 32 : t10;
    t1 = "http://www.w3.org/2000/svg";
    t2 = width ?? size;
    t3 = height ?? size;
    t4 = "0 0 32 32";
    t5 = "none";
    t6 = "true";
    t7 = "img";
    t8 = "Python logo";
    t9 = cn("stroke-[#1D4ED8]", props.className);
    $[0] = t0;
    $[1] = props;
    $[2] = t1;
    $[3] = t2;
    $[4] = t3;
    $[5] = t4;
    $[6] = t5;
    $[7] = t6;
    $[8] = t7;
    $[9] = t8;
    $[10] = t9;
  } else {
    props = $[1];
    t1 = $[2];
    t2 = $[3];
    t3 = $[4];
    t4 = $[5];
    t5 = $[6];
    t6 = $[7];
    t7 = $[8];
    t8 = $[9];
    t9 = $[10];
  }
  let t10;
  if ($[11] === Symbol.for("react.memo_cache_sentinel")) {
    t10 = <g clipPath="url(#clip0_7979_16494)"><path d="M16 12H6.66667C5.95942 12 5.28115 12.281 4.78105 12.781C4.28095 13.2811 4 13.9594 4 14.6667V20C4 20.7072 4.28095 21.3855 4.78105 21.8856C5.28115 22.3857 5.95942 22.6667 6.66667 22.6667H10.6667" strokeWidth="2.66667" strokeLinecap="round" strokeLinejoin="round" /><path d="M16 19.9997H25.3333C26.0406 19.9997 26.7189 19.7187 27.219 19.2186C27.719 18.7185 28 18.0403 28 17.333V11.9997C28 11.2924 27.719 10.6142 27.219 10.1141C26.7189 9.61396 26.0406 9.33301 25.3333 9.33301H21.3333" strokeWidth="2.66667" strokeLinecap="round" strokeLinejoin="round" /><path d="M10.667 12V6.66667C10.667 5.95942 10.9479 5.28115 11.448 4.78105C11.9481 4.28095 12.6264 4 13.3337 4H18.667C19.3742 4 20.0525 4.28095 20.5526 4.78105C21.0527 5.28115 21.3337 5.95942 21.3337 6.66667V13.3333C21.3337 14.0406 21.0527 14.7189 20.5526 15.219C20.0525 15.719 19.3742 16 18.667 16H13.3337C12.6264 16 11.9481 16.281 11.448 16.781C10.9479 17.2811 10.667 17.9594 10.667 18.6667V25.3333C10.667 26.0406 10.9479 26.7189 11.448 27.219C11.9481 27.719 12.6264 28 13.3337 28H18.667C19.3742 28 20.0525 27.719 20.5526 27.219C21.0527 26.7189 21.3337 26.0406 21.3337 25.3333V20" strokeWidth="2.66667" strokeLinecap="round" strokeLinejoin="round" /><path d="M14.667 8V8.01333" strokeWidth="2.66667" strokeLinecap="round" strokeLinejoin="round" /><path d="M17.333 24V24.0133" strokeWidth="2.66667" strokeLinecap="round" strokeLinejoin="round" /></g>;
    $[11] = t10;
  } else {
    t10 = $[11];
  }
  let t11;
  if ($[12] === Symbol.for("react.memo_cache_sentinel")) {
    t11 = <defs><clipPath id="clip0_7979_16494"><rect width="32" height="32" fill="white" /></clipPath></defs>;
    $[12] = t11;
  } else {
    t11 = $[12];
  }
  let t12;
  if ($[13] !== props || $[14] !== t1 || $[15] !== t2 || $[16] !== t3 || $[17] !== t4 || $[18] !== t5 || $[19] !== t6 || $[20] !== t7 || $[21] !== t8 || $[22] !== t9) {
    t12 = <svg xmlns={t1} width={t2} height={t3} viewBox={t4} fill={t5} aria-hidden={t6} role={t7} aria-label={t8} className={t9} {...props}>{t10}{t11}</svg>;
    $[13] = props;
    $[14] = t1;
    $[15] = t2;
    $[16] = t3;
    $[17] = t4;
    $[18] = t5;
    $[19] = t6;
    $[20] = t7;
    $[21] = t8;
    $[22] = t9;
    $[23] = t12;
  } else {
    t12 = $[23];
  }
  return t12;
};